import { z } from 'zod';
/** Estado público de un health check. No describe dependencias internas. */
export const HealthStatusSchema = z.enum(['ok', 'unavailable']);
/**
 * Respuesta de `GET /health/live` y, más adelante, `GET /health/ready`.
 * Es estricta: cualquier propiedad adicional (versiones, rutas, variables) invalida la respuesta.
 */
export const HealthResponseSchema = z.strictObject({
    status: HealthStatusSchema,
});
//# sourceMappingURL=health.js.map